<div class="header">
    <p>Curators ({{totalRecords}})</p>
    <img src="/assets/icons/Close.svg" alt="close" (click)="closeDialog()" />
</div>
<mat-divider></mat-divider>
<div class="tables-grid curator-list-container">
    <mat-card class="data-table-card">
        <div style="display: flex; align-items: center; padding: 0px 16px; gap: 12px;">
            <div class="position-relative search-input-box">
                <input type="text" placeholder="Search" class="p-8 search-input" style="width: 94%; font-size: 14px;"
                    [(ngModel)]="searchtextData" (ngModelChange)="onSearchChange()" #searchInput>
                <div class="position-absolute search-icon cursor-pointer">
                    <div class="d-flex align-items-center" style="gap: 8px;">
                        <img src="/assets/admin-images/search_cancel_icon.png" style="height: 20px;" alt="search"
                            (click)="clearSearch()" *ngIf="searchtextData">
                        <span style="color: #E1E1EA;" *ngIf="searchtextData">|</span>
                        <img src="/assets/icons/Group 57082.svg" alt="search" (click)="searchData(searchtextData)">
                    </div>
                </div>
            </div>
            <div class="pagination-container">

                <mat-paginator #paginator [length]="totalRecords" [pageSize]="pageSize" [pageIndex]="pageIndex"
                    [pageSizeOptions]="pageSizeOptions" (page)="onPageChange($event)">
                </mat-paginator>

                <div class="page-dropdown">
                    <mat-select [(ngModel)]="pageIndex" (selectionChange)="onPageChangeFromDropdown($event)">
                        <mat-option *ngFor="let page of pageNumbers" [value]="page" style="font-family: lato, sans-serif;">{{ page +
                            1 }}</mat-option>
                    </mat-select>
                </div>
            </div>
        </div>

        <table mat-table [dataSource]="dataSource" *ngIf="curatorListData?.length > 0" aria-label="curator list data">
            <ng-container matColumnDef="rank">
                <th mat-header-cell *matHeaderCellDef style="width: 10%;">Place</th>
                <td mat-cell *matCellDef="let row;">
                    <div class="ellipsis-text">{{ row?.rank }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="curator_name">
                <th mat-header-cell *matHeaderCellDef style="width: 20%;">Name</th>
                <td mat-cell *matCellDef="let row">
                    <div class="ellipsis-text" title="{{ row?.curator_name }}">{{ row?.curator_name }}</div>
                </td>
            </ng-container>
            <ng-container matColumnDef="category">
                <th mat-header-cell *matHeaderCellDef style="width: 25%;">Category</th>
                <td mat-cell *matCellDef="let row">
                    <span *ngIf="row?.category?.length" style="display: flex;">
                        <span class="single-line-ellipsis" title="{{ row?.category[0] }}">{{ row?.category[0] }}</span>
                        <ng-container *ngIf="row?.category?.length > 1">
                        <span class="more-count" style="white-space: nowrap;" [matTooltip]="row?.category?.slice(1).join(', ')" matTooltipPosition="above">+{{ row?.category?.length - 1 }}</span>
                        </ng-container>
                    </span>
                </td>
            </ng-container>
            <ng-container matColumnDef="reviewed">
                <th mat-header-cell *matHeaderCellDef style="position: relative; width: 15%;"><span style="margin-right: 10px;">Reviewed</span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_filled_arrow.svg" alt="up_filled_arrow" (click)="sortingByAsc('reviewed')" *ngIf="reviewedAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_filled_arrow.svg" alt="down_filled_arrow" (click)="sortingByDes('reviewed')" *ngIf="reviewedDesSort"/></span>
                    <span style="position: absolute; top: 10px;"><img src="/assets/admin-images/up_sort_arrow.svg" alt="up_filled_arrow" *ngIf="!reviewedAscSort"/></span> 
                    <span style="position: absolute; bottom: 10px;"><img src="/assets/admin-images/down_sort_arrow.svg" alt="down_sort_arrow" *ngIf="!reviewedDesSort"/></span>
                </th>
                <td mat-cell *matCellDef="let row">{{ row?.reviewed }}</td>
            </ng-container>
            <ng-container matColumnDef="approved">
                <th mat-header-cell *matHeaderCellDef style="width: 15%;">Approved</th>
                <td mat-cell *matCellDef="let row">{{ row?.approved }}</td>
            </ng-container>
            <ng-container matColumnDef="rejected">
                <th mat-header-cell *matHeaderCellDef style="width: 15%;">Rejected</th>
                <td mat-cell *matCellDef="let row">{{ row?.rejected }}</td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
        </table>
        <div *ngIf="curatorListData?.length <= 0" style="margin: 70px; font-size: 24px; font-weight: 700; text-align: center;">
            No records found.
        </div>
    </mat-card>
</div>

<div style="display: flex;justify-content: center;">
@if(isLoading){
     <mat-spinner  diameter="40"></mat-spinner>
    }
</div>
